module.exports = __webpack_public_path__ + "static/media/booking-now.008851c9.webp";